import { render } from "./DhMap.vue?vue&type=template&id=20ccc2df"
import script from "./DhMap.vue?vue&type=script&lang=ts"
export * from "./DhMap.vue?vue&type=script&lang=ts"
script.render = render

export default script